
import smallCardAlt from '../cards/smallCardAlt.vue'
export default {
    name:"results",
    components: {smallCardAlt},
    props:
    {
        content: Object
    }
}
